import { ImMap } from '../helpers/ImmutableTypes';

export interface Media {
  promoImageUrl: string;
  promoVideoUrl: string;
}

export interface Portal {
  isLive: boolean;
  isOnline: boolean;
  externalEnrolmentLink: string;
  subscriptionPaymentUrl: string;
  name: string;
  autoAddNewUsersToPortal: boolean;
  media: ImMap<Media>;
  institutionName: string;
  externalLogInLink: string | null;
  externalLogOutLink: string | null;
  externalSignUpLink: string | null;
}

export type WhiteLabelItemVisibilities = Record<string, boolean>;

export enum WhiteLabelVisibilitySettingNames {
  isSearchVisible = 'isSearchVisible',
  isCourseNavigationVisible = 'isCourseNavigationVisible',
  isLanguageSelectorVisible = 'isLanguageSelectorVisible',
  isAccountMenuProfileVisible = 'isAccountMenuProfileVisible',
  isAccountMenuInformationVisible = 'isAccountMenuInformationVisible',
  isAccountMenuChatHistoryVisible = 'isAccountMenuChatHistoryVisible',
}

export enum WhiteLabelItemVisibilityRoleSetting {
  showAllForAdmin = 'show_all_for_admin',
  normal = 'normal',
}
